module.exports = __webpack_public_path__ + "img/gartek-portfolio-continuing-services.d6331650.jpeg";